export default __webpack_public_path__ + "static/media/1.230c69bf.png";